import type { AskErrorKind } from '@/services/ask/errors';

export const SEND_FAILURE_TITLE = 'Question not sent';

const UNKNOWN_FAILURE_MESSAGE = 'Something went wrong sending your question. Send it again.';

const FAILURE_MESSAGES: Partial<Record<AskErrorKind, string>> = {
  LIKELY_IDENTIFIER:
    'This looks like it may include a patient identifier, such as an MRN, date of birth or name. Remove it and send again.',
  network: "Your question didn't send. Check your connection and send it again.",
  TURN_IN_PROGRESS:
    'Another question in this topic is still running, perhaps on another device. Send yours when it finishes.',
  CONVERSATION_ADVANCED: 'This topic changed on another device. Send your question again.',
  CONVERSATION_LIMIT_REACHED: 'This research topic is full. Start a new one to keep going.',
  invalid: 'We couldn’t read that question. Add a little more detail and send it again.',
  npi_required: 'Verify your NPI to ask the Inquiry Library this way.',
  forbidden: "Your account doesn't have access to Research yet.",
};

/** Toast copy for a question the server refused, from the composer or a retry, by kind. */
export function sendFailureMessage(kind: AskErrorKind): string {
  return FAILURE_MESSAGES[kind] ?? UNKNOWN_FAILURE_MESSAGE;
}
